export default "__VITE_ASSET__CJhmH0AC__"